import './chart-torta.scss';
import PubSub from 'pubsub-js';
import Chart from 'chart.js/auto';
import { PageEvents } from './page';

const COMPONENT_NAME = 'chart-torta';

const BEM = {
  BLOCK: COMPONENT_NAME,
};

const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart) {
    const legendContainer = chart.canvas.closest('.chart-torta').querySelector('.chart-torta__legend');

    let ul = legendContainer.querySelector('ul');
    if (!ul) {
      ul = document.createElement('ul');
      ul.setAttribute('role', 'list');
      legendContainer.appendChild(ul);
    }

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);
    items.forEach((item) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'listitem');
      li.setAttribute('tabindex', '0');
      li.onclick = () => {
        const { type } = chart.config;
        if (type === 'pie' || type === 'doughnut') {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };
      li.onkeypress = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          li.click();
        }
      };

      // Color box
      const boxSpan = document.createElement('span');
      boxSpan.style.background = item.fillStyle;
      boxSpan.style.borderColor = item.strokeStyle;
      boxSpan.style.borderWidth = `${item.lineWidth}px`;

      // Text
      const textContainer = document.createElement('p');
      textContainer.style.color = item.fontColor;
      textContainer.style.margin = 0;
      textContainer.style.padding = 0;
      textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

      const value = chart.data.datasets[0].data[item.index];
      const text = document.createTextNode(`${item.text}: ${value}%`);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      ul.appendChild(li);
    });
  },
};

/**
 * version    1.0
 * class      <type> (ChartTorta)
 */
export class ChartTorta {
  constructor($container = $('body')) {
    // const self = this;

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.chartTorta = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.chartTorta.each((index, element) => {
        this._initSingleInstance($(element), index);
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    const canvas = $instanceEl.find('canvas')[0];

    // Get data from data attributes
    const labels = JSON.parse(canvas.dataset.labels || '[]');
    const values = JSON.parse(canvas.dataset.values || '[]');
    const colors = JSON.parse(canvas.dataset.colors || '[]');

    // Generate descriptive aria-label
    const description = labels.map((label, i) => `${label}: ${values[i]}%`).join(', ');
    canvas.setAttribute('aria-label', `${canvas.getAttribute('aria-label')} - ${description}`);

    // Create chart instance
    new Chart(canvas, { // eslint-disable-line no-new
      type: 'doughnut',
      data: {
        labels,
        datasets: [{
          data: values,
          backgroundColor: colors,
          borderWidth: 0,
        }],
      },
      plugins: [htmlLegendPlugin],
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          htmlLegend: {
            containerID: null, // No longer needed
          },
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: context => ` ${context.label}: ${context.raw}%`,
            },
          },
        },
        cutout: '70%',
      },
    });
  }
}
